import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-content">
                    <div className="footer-left">
                        <p className="footer-copyright">© 2024 NeuAIs. All rights reserved.</p>
                    </div>
                    <div className="footer-links">
                        <Link to="/about" className="footer-link">About</Link>
                        <Link to="/contact" className="footer-link">Contact</Link>
                        <Link to="/privacy" className="footer-link">Privacy</Link>
                        <Link to="/terms" className="footer-link">Terms</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
